import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPage.css";
import { Header, Sidebar } from "../common";

const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

const AdminPage = () => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [buildings, setBuildings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${BACK_API_BASE_URL}/api/user/load/allUserInfo`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("token"),
            },
            method: "GET",
          }
        );

        if (response.ok) {
          const data = await response.json();
          setUsers(data);
        } else {
          console.error("Failed to fetch users:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const handleChangePassword = async () => {
    const newPassword = prompt("새로운 비밀번호를 입력하세요:");

    if (!newPassword) {
      alert("비밀번호가 입력되지 않았습니다!");
      return;
    }

    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/user/changePassword`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "POST",
          body: JSON.stringify({
            password: newPassword,
          }),
        }
      );

      if (response.ok) {
        alert("비밀번호가 성공적으로 변경되었습니다.");
      } else {
        const errorData = await response.json();
        alert(errorData.errors[0]);
      }
    } catch (error) {
      console.error("비밀번호 변경 중 오류 발생:", error);
      alert("비밀번호 변경 중 오류가 발생했습니다.!!!!!");
    }
  };

  const handleUserClick = async (userId) => {
    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/building/load/all?userId=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log("유저클릭:", data)
        setBuildings(data);
        setSelectedUser(userId);
      } else {
        console.error("Failed to fetch buildings:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching buildings:", error);
    }
  };

  const handleBuildingClick = (buildingId) => {
    navigate(`/building-detail/${buildingId}`);
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm("정말로 이 유저를 삭제하시겠습니까?")) {
      return;
    }

    try {
      const response = await fetch(
        `${BACK_API_BASE_URL}/api/user/delete/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          method: "GET",
        }
      );

      if (response.ok) {
        alert("유저가 성공적으로 삭제되었습니다.");
        setUsers(users.filter((user) => user.userId !== userId));
        if (selectedUser === userId) {
          setSelectedUser(null);
          setBuildings([]);
        }
      } else {
        const errorData = await response.json();
        alert(errorData.errors || "유저 삭제 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("유저 삭제 중 오류 발생:", error);
      alert("유저 삭제 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="admin-page">
      <Sidebar />
      <div className="sideBarElseContainer">
        <Header pageName="Admin Page" />
        <div className="content-container">
          {/* <button className='change-password-button' onClick={handleChangePassword}>
                관리자 비밀 번호 변경
              </button> */}
          <div className="users-list-container">
            <h2>User List</h2>
            <div className="user-list">
              {users.map((user) => (
                <div
                  className={`user-list-row ${
                    selectedUser === user.userId ? "selected" : ""
                  }`}
                  key={user.userId}
                  onClick={() => handleUserClick(user.userId)}
                >
                  {user.userName} ({user.email})
                  <button
                    className="delete-user-button"
                    onClick={() => handleDeleteUser(user.userId)}
                  >
                    삭제
                  </button>
                </div>
              ))}
            </div>
          </div>
          {selectedUser && (
            <div className="user-building-list-container">
              <h2>Buildings for User</h2>
              <div className="user-building-list">
                {buildings.map((building) => (
                  <div
                    className="user-building-list-row"
                    key={building.id}
                    onClick={() => handleBuildingClick(building.id)}
                  >
                    {building.buildingName}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
